export default __webpack_public_path__ + "static/media/lifeInsurance.0daa7612.svg";